/** Multiline editor inside pricing confirm cards. */
export const pricingMultilineFieldClass =
  'w-full rounded-lg border-0 bg-twin-chat-bubble/50 px-2.5 py-1.5 text-sm text-twin-chat-fg placeholder:text-twin-chat-fg-muted focus:outline-none focus:ring-1 focus:ring-ring disabled:opacity-50'

/** Single-line editor — standard shell input tokens. */
export const pricingInlineFieldClass =
  'w-full rounded-lg border border-input bg-background px-2.5 py-1.5 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:opacity-50'
